import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { ComponentRoutingModule } from './component-routing.module';

import { ShuttleBoxComponent } from './shuttle-box/shuttle-box.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { FormTitleComponent } from './form-title/form-title.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { GlobalLoadingComponent } from './global-loading/global-loading.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { TransferComponent } from './transfer/transfer.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { CreativeLabelComponent } from './creative-label/creative-label.component';
import { NgxQuillComponent } from './ngx-quill/ngx-quill.component';
import { QuillModule } from 'ngx-quill';
import { FormErrorComponent } from './form-error/form-error.component';
import { MapComponent } from './map/map.component';
import { MoveRecordComponent } from './move-record/move-record.component';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { OrganComponent } from './organ/organ.component';
import { ApprovalComponent } from './approval/approval.component';
import { StructureComponent } from './structure/structure.component';
import { EmployeeSelectComponent } from './employee-select/employee-select.component';
import { StructureSelectComponent } from './structure-select/structure-select.component';
import { MoveRecordItemComponent } from './move-record-item/move-record-item.component';
import { SlideVerifyComponent } from './slide-verify/slide-verify.component';
import { EditorDutiesComponent } from './editor-duties/editor-duties.component';
import { DutiesTreeComponent } from './duties-tree/duties-tree.component';
import { DutiesSelectComponent } from './duties-select/duties-select.component';
import { StructurePeopleComponent } from './structure-people/structure-people.component';
import { InviteDutiesSelectComponent } from './invite-duties-select/invite-duties-select.component';
import { StructureSelectMultipleComponent } from './structure-select-multiple/structure-select-multiple.component';
import { TimeSelectComponent } from './time-select/time-select.component';
import { MapPreviewComponent } from './map-preview/map-preview.component';
import { ManagementTableComponent } from './management-table/management-table.component';
import { PlanDutiesComponent } from './plan-duties/plan-duties.component';
import { PipesModule } from '../pipes/pipes.module';
@NgModule({
  declarations: [
    ConfirmComponent,
    ShuttleBoxComponent,
    FormTitleComponent,
    RadioButtonComponent,
    GlobalLoadingComponent,
    FileUploadComponent,
    TransferComponent,
    FeedbackComponent,
    ColorPickerComponent,
    CreativeLabelComponent,
    NgxQuillComponent,
    FormErrorComponent,
    MapComponent,
    MoveRecordComponent,
    OrganComponent,
    ApprovalComponent,
    StructureComponent,
    EmployeeSelectComponent,
    StructureSelectComponent,
    MoveRecordItemComponent,
    SlideVerifyComponent,
    EditorDutiesComponent,
    DutiesTreeComponent,
    DutiesSelectComponent,
    StructurePeopleComponent,
    InviteDutiesSelectComponent,
    StructureSelectMultipleComponent,
    TimeSelectComponent,
    MapPreviewComponent,
    ManagementTableComponent,
    PlanDutiesComponent,
  ],
  imports: [
    CommonModule,
    ComponentRoutingModule,
    NzInputModule,
    NzButtonModule,
    NzSpinModule,
    NzIconModule,
    FormsModule,
    NzModalModule,
    NzTagModule,
    SharedModule,
    NzTreeModule,
    ScrollingModule,
    ColorPickerModule,
    QuillModule,
    NzTimelineModule,
    PipesModule,
  ],
  exports: [
    ConfirmComponent,
    ShuttleBoxComponent,
    FormTitleComponent,
    RadioButtonComponent,
    GlobalLoadingComponent,
    FileUploadComponent,
    TransferComponent,
    FeedbackComponent,
    ColorPickerComponent,
    CreativeLabelComponent,
    NgxQuillComponent,
    FormErrorComponent,
    MapComponent,
    MoveRecordComponent,
    OrganComponent,
    ApprovalComponent,
    StructureComponent,
    EmployeeSelectComponent,
    StructureSelectComponent,
    MoveRecordItemComponent,
    SlideVerifyComponent,
    EditorDutiesComponent,
    DutiesTreeComponent,
    DutiesSelectComponent,
    StructurePeopleComponent,
    InviteDutiesSelectComponent,
    StructureSelectMultipleComponent,
    TimeSelectComponent,
    MapPreviewComponent,
    ManagementTableComponent,
    PlanDutiesComponent,
    PlanDutiesComponent,
  ],
})
export class ComponentModule {}
